export default {
  edit: {
    attributes: [
      {attribute: "entryDate"}
    ]
  }
}
